export default {
  maximumSelect: 'Maximum 15 items can be selected',
  maximumFiveSelect: 'Maximum 5 items can be selected',
  simpleRegistration: {
    skill: 'Skills & Experience',
    job: 'Job Experience',
    japanese: 'Japanese',
    japaneseLevel: 'Japanese Level',
    jlpt: 'JLPT',
    preference: 'Preference',
    basicInformation: 'Basic Information',
    career: 'Career',
    jobPlaceholder: 'Search by job title (e.g., AI engineer, Bridge SE)',
    skillPlaceholder: 'Search by experience skill name (e.g. Java, AWS)',
    jlptDescription1: '*JLPT＝Japanese Language Proficiency Test',
    jlptDescription2: '*If you do not have a JLPT certification, please select "None."',
    currentAnnualSalary: 'Current Annual Salary',
    addPastCompanies: 'Add Past Employers',
    previousEmployers: 'Past Employers',
    previousEmployersDescription: 'The list is automatically sorted from newest to oldest.',
    companyNameMostRecent: 'Company name (most recent employer)',
    aiGeneratedButton: 'AI Generated',
    role: 'Role',
    aiModal: {
      jobTitle: 'Job Title',
      jobTitlePlaceholder: 'Example: Backend Engineer',
      role: 'Role',
      rolePlaceholder: 'Example: Tech Lead',
      jobDescription: 'Job Overview',
      jobDescriptionPlaceholder: 'Example: Backend development and API design for in-house core systems using Java/Spring',
      jobDescriptionHint: 'This information will be used as the source to generate job details using AI.',
      projectTaskDetails: 'Project / Task Details',
      startGeneration: 'Start Generation',
      cancel: 'Cancel',
      regenerate: 'Regenerate',
      overwriteDetails: 'Overwrite Job Details',
      aiGeneratedDisclaimer: 'The text above was generated by AI. Please review and edit it to match your experience before submission.',
      termsTitle: 'Notes on AI-Generated Job Details',
      termsItem1: 'This feature is intended to assist with generating job details and does not guarantee the accuracy or appropriateness of the content.',
      termsItem2: 'Please do not enter confidential information of companies you have worked for or been involved with, or personal information of other people.',
      termsItem3: 'This feature has a limited number of uses.',
      termsItem4: 'Please make sure to review and edit AI-generated content yourself before using it.',
      termsItem5: 'Clicking "Overwrite Job Details" after generation will overwrite your currently entered work history.',
      termsAgree: 'I agree to the above terms and conditions.',
      retry: 'Retry',
      errorLimitReached: 'You have reached the maximum number of generation attempts.',
      errorServiceUnavailable: 'The AI service is currently unavailable. Please try again later.',
      errorTimeout: 'The request timed out. Please try again.',
      errorValidation: 'Invalid input. Please check your entries and try again.',
      errorNetwork: 'Network error. Please check your connection and try again.',
      errorGeneric: 'An unexpected error occurred. Please try again.'
    },
    workDetail: 'Project / Task Details',
    workDetailPlaceholder:
      'Project: E-commerce Site Backend Development\n' +
      'Key Responsibilities:\n' +
      '・Developed the backend of a web application.\n' +
      '・Built REST APIs using Spring Boot and Kotlin, implementing features such as payment systems and product management functions.\n' +
      '・Leveraged AWS services to reduce costs and improve scalability.',
    workDetailForm: {
      validations: {
        workDetail: {
          required: 'Project / Task Details is required',
          maxLength: 'Project / Task Details must not exceed 4000 characters',
          notIn: 'This field is to be modified from the template.'
        },
      }
    }
  },
  steps: {
    step1: 'Step 1',
    step2: 'Step 2',
    step3: 'Step 3',
    step4: 'Step 4',
    step5: 'Step 5',
    step6: 'Step 6'
  },
  next: 'Next',
  back: 'Back',
  complete: 'Complete',
  steppers: {
    '01': 'Language',
    '02': 'Skill/Experience',
    '03': 'Preference',
    '✓': 'Finish'
  },
  finish: {
    completed: 'Registration Completed',
    find: "Let's find a job!",
    search: 'Job Search',
    failed: 'Sorry, registration failed!',
    try: 'Please try again later or contact us.',
    back: 'Back To Home',
    next: 'Go on to the next',
    profile: 'Additional Information',
    info: {
      line1: 'Required fields have been filled.',
      line2:
        'Let us add more details to your profile to make it more attractive.',
      line3:
        'Additional profile information rapidly increase your chances of receiving job offers.'
    }
  },

  experience: {
    skill: 'Skill',
    currentStatus: 'Current Status',
    work: 'Work',
    education: 'Educational background',
    personalInformation: 'Personal Information'
  },
  help: {
    title: 'Help',
    nativeLanguage: {
      title: 'Native Language',
      body: 'if you have more than two, chose one'
    },
    speakingEnglish: {
      title: 'Speaking English/Japanese',
      body: `<strong class="foreground--text">Native:</strong>
      The level of speaking as a native speaker (1st language / mother tongue).

      <strong class="foreground--text">Fluent:</strong>
      Well advanced in any occupation or branch of knowledge.
      
      <strong class="foreground--text">Business:</strong>
      Capable of using a language easily and accurately in business.
      
      <strong class="foreground--text">Daily conversation:</strong>
      The level of speaking with certain phrases and simple word in a casual situation.

      <strong class="foreground--text">Greeting/None:</strong>
      The level of speaking with simple phrases or YES  NO for greeting or self-introduction.`
    },
    jlpt: {
      title: 'JLPT',
      body: `<strong class="foreground--text">N1:</strong>
      The ability to understand Japanese used in a variety of circumstances.
      
      <strong class="foreground--text">N2:</strong>
      The ability to understand Japanese used in everyday situations, and in a variety of circumstances to a certain degree.

      <strong class="foreground--text">N3:</strong>
      The ability to understand Japanese used in everyday situations to a certain degree.

      <strong class="foreground--text">N4:</strong>
      The ability to understand basic Japanese.

      <strong class="foreground--text">N5:</strong>
      The ability to understand some basic Japanese.
      `
    },
    autoFillOut: {
      title: 'Auto fill out',
      body: 'If you have CV file, our system will parse it and help to fill in some fields (one time).'
    },
    gtalent: {
      title: 'What is G  Talent ?',
      body: 'G Talent is recruitment agency specialized in Global IT Talent in Japan. Some recruiters specialized IT industries support you get jobs in Japan.'
    }
  },
  tips: {
    default: {
      header: 'Welcome to GitTap',
      tip: `Fill out your information.
      Get Scouted!!
      
      If you have any question, click question mark. HELP will be showed up here.`
    },
    prefectures: {
      header: 'Select prefectures',
      tip: 'You can choose prefectures'
    },
    industry: {
      header: 'Select Industry',
      tip: 'You can choose industry'
    },
    itSkill: {
      header: 'Select IT skills',
      tip: 'You can select your IT skills.'
    },
    jobRole: {
      header: 'Select job roles',
      tip: 'You can select your experienced job role.'
    },
    school: {
      header: 'Input schools',
      tip: 'You can input your educational background.'
    },
    company: {
      header: 'Add Company',
      tip: 'Added company will be sorted automatically.'
    }
  },
  registerToGTalent:
    'Register to <a href="https://www.gtalent.jp/en" target="_blank" class="primary--text" style="text-decoration: none">G Talent</a> [Our job hunting services]',
  informationAccuracyConfirmation: 'I confirm that the information entered (work history, skills, etc.) is accurate and true.',
  informationAccuracyWarning: '※If any information is found to be false, your account may be suspended in accordance with our Terms of Service.',
  workRemotelyFromOverseas: 'If possible, work remotely from overseas',
  gTalentHelp:
    '<strong>“G Talent”</strong> is a recruitment agency which specializes in assisting Global IT Talent in their job search in Japan. Recruiters who are specialized in the IT industries will support you to land your dream opportunity in Japan.',
  gTalentDescription:
    'You can also Register to <strong>“G Talent”</strong>, which is our job hunting service.[Please Note : When applying to our services, it is<br>necessary to agree to the <a href="https://www.gtalent.jp/en/attention" target="_blank" class="primary--text" style="text-decoration: none">terms of use</a> and to provide consent<br> for <a href="https://www.gtalent.jp/en/privacy/member_reg" target="_blank" class="primary--text" style="text-decoration: none">handling of personal information</a>(i.e member information). Please read and review the terms and conditions of this Agreement carefully before using this Service.]',
  yearsOfExperience: {
    fiveYears: '5+ years',
    threeToFiveYears: '3 - 5 years',
    oneToThreeYears: '1 - 3 years',
    lessThanOneYear: 'Less than a year'
  },
  welcome: {
    header: 'Welcome to GitTap',
    item1: 'Registration is not yet complete. <br> Fulfill your profile first.',
    item2:
      'The screening pass rate and scout reception rate will greatly increase.',
    enterManually: 'Enter Manually'
  }
}
